<template>
  <div>
  </div>
</template>
<script>

export default {
  name: 'clubMembershipExtra',
  props: ['value'],
  data() {
    return {
      inputValue: '',
      inputVisible: false,
      selectedName: '',
      selectedClubs: []
    };
  },
  mounted() {
    if (this.value.meta && this.value.meta.homeClub) this.selectedName = this.value.meta.homeClub.name;
    if (this.value.meta && this.value.meta.clubs) this.selectedClubs = this.value.meta.clubs.map((club) => ({ _id: club._id, value: club.name }));
    this.$http.post('/assemble/api/v1/portal/clubs/search', { criteria: '' }).then((res) => {
      const data = res.data.data.map((c) => ({ value: c.name, _id: c._id }));
      // Append none
      data.unshift({ value: 'None', _id: 'none' });
      this.clubs = data;
    }).catch(() => {});
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
